import styled from 'styled-components';

export const CapitalizedP = styled.p`
  text-transform: capitalize;
`;

export const CardHeader = styled.div`
  align-items: center;
  background-color: var(--color-bg-weak);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 4px;
  width: fit-content;
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Row = styled.div`
  display: flex;
  flex: 1;
`;

export const VerticalDivider = styled.div`
  background-color: var(--color-accent-secondary-weaker);
  height: 24px;
  margin: 0 8px;
  width: 1px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;

  .card-wrapper {
    padding: 16px 24px;
  }
`;
